import { useState, useRef, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { SERVER_API } from "../../fileWithConstants";

const AddDupattaKali = () => {
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [supplierList, setSupplierList] = useState([]);
   const [supplier, setSupplier] = useState("");
  const [qty, setQty] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  const [validated, setValidated] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // IMAGE CHANGE
  const onFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only PNG, JPG, JPEG allowed");
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      toast.error("Image must be less than 10MB");
      return;
    }

    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  // SUBMIT FORM
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    try {
      setSubmitting(true);

      const formData = new FormData();

      formData.append("name", name);
      formData.append("type", type);
      formData.append("supplier", supplier);
      formData.append("qty", qty);
      formData.append("price", price);

      if (image) {
        formData.append("image", image);
      }

      const { data } = await axios.post(
        `${SERVER_API}/api/v1/element/add-dupatta-kali`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (data?.success) {
        toast.success(data.message);

        setName("");
        setType("");
        setQty("");
        setPrice("");
        setImage(null);
        setPreview(null);
        // clear file input
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setValidated(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  // CANCEL
  const cancelHandle = () => {
    navigate("/dashboard/dupatta-kali-list");
  };

const getAllSupplier = async()=>{
  try {
    const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-all-supplier`);
    if(data?.success && data?.suppliers?.length>0){
      setSupplierList(data?.suppliers)
      console.log(data?.suppliers)
    }
  } catch (error) {
    console.log(error)
  }
}

  useEffect(() => {
  getAllSupplier();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  return (
    <Layout title={"Add Dupatta/Kali"}>
      <div className="form-container">
        <Form
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
          className="form-section"
        >
          <h4 className="title">Add Dupatta/Kali/Sets</h4>

          <div className="form-box">
            {/* NAME */}

            <Form.Group className="mb-3">
              <Form.Label>Name*</Form.Label>

              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />

              <Form.Control.Feedback type="invalid">
                Please enter name
              </Form.Control.Feedback>
            </Form.Group>

            {/* TYPE */}

            <Form.Group className="mb-3">
              <Form.Label>Type*</Form.Label>

              <Form.Select
                value={type}
                onChange={(e) => setType(e.target.value)}
                required
              >
                <option value="">--Select--</option>
                <option value="3">Blouse</option>
                <option value="6">Dupatta</option>
                <option value="51">Kali</option>
                <option value="52">Set (Kali + Dupatta)</option>
                <option value="53">Set (Kali + Blouse)</option>
                <option value="54">Set (Dupatta + Blouse)</option>
                <option value="55">Set (Kali + Dupatta + Blouse)</option>
              </Form.Select>

              <Form.Control.Feedback type="invalid">
                Please select type
              </Form.Control.Feedback>
            </Form.Group>

             {/* Supplier */}
            <Form.Group className="mb-3">
                <Form.Label>Supplier*</Form.Label>

                <Form.Select
                  value={supplier}
                  onChange={(e) => setSupplier(e.target.value)}
                  required
                >
                  <option value="">--Select--</option>

                  {supplierList?.map((item) => (
                    <option key={item.v_id} value={item.v_id}>
                      {item.code}
                    </option>
                  ))}
                </Form.Select>

                <Form.Control.Feedback type="invalid">
                  Please select supplier
                </Form.Control.Feedback>
              </Form.Group>


            {/* Price */}

            <Form.Group className="mb-3">
              <Form.Label>Price/Pc*</Form.Label>

              <Form.Control
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />

              <Form.Control.Feedback type="invalid">
                Please enter price
              </Form.Control.Feedback>
            </Form.Group>


            {/* QTY */}

            <Form.Group className="mb-3">
              <Form.Label>QTY*</Form.Label>

              <Form.Control
                type="number"
                value={qty}
                onChange={(e) => setQty(e.target.value)}
                required
              />

              <Form.Control.Feedback type="invalid">
                Please enter quantity
              </Form.Control.Feedback>
            </Form.Group>

            {/* IMAGE */}

            <Form.Group className="mb-3">
              <Form.Label>Picture Upload*</Form.Label>

              <Form.Control
                ref={fileInputRef}
                type="file"
                accept="image/png,image/jpeg,image/jpg"
                onChange={onFileChange}
                required
              />

              <Form.Control.Feedback type="invalid">
                Please upload image
              </Form.Control.Feedback>
            </Form.Group>

            {/* IMAGE PREVIEW */}

            {preview && (
              <div className="mb-3">
                <img
                  src={preview}
                  alt="preview"
                  style={{
                    width: "150px",
                    borderRadius: "6px",
                    border: "1px solid #ddd",
                    padding: "5px",
                  }}
                />
              </div>
            )}

            {/* BUTTONS */}

            <div className="row">
              <div className="col-6">
                <button
                  type="submit"
                  className="btn btn-dark form-control"
                  disabled={submitting}
                >
                  {submitting ? "Adding..." : "Add"}
                </button>
              </div>

              <div className="col-6">
                <button
                  type="button"
                  onClick={cancelHandle}
                  className="btn btn-secondary form-control"
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </Layout>
  );
};

export default AddDupattaKali;
